'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Check, Globe, Languages } from 'lucide-react';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { usePathname, useRouter } from '@/core/i18n/navigation';
import { localeNames } from '@/config/locale';
import { Button } from '@/shared/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/shared/components/ui/dropdown-menu';
import { cacheSet } from '@/shared/lib/cache';
export function LocaleSelector(t0) {
  const $ = _c(25);
  const {
    type: t1
  } = t0;
  const type = t1 === undefined ? "icon" : t1;
  const currentLocale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== currentLocale || $[3] !== pathname || $[4] !== router || $[5] !== searchParams) {
    t4 = value => {
      if (value !== currentLocale) {
        cacheSet("locale", value);
        const query = searchParams?.toString?.() ?? "";
        const href = query ? `${pathname}?${query}` : pathname;
        router.push(href, {
          locale: value
        });
      }
    };
    $[2] = currentLocale;
    $[3] = pathname;
    $[4] = router;
    $[5] = searchParams;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSwitchLanguage = t4;
  if (!mounted) {
    const t5 = type === "icon" ? "ghost" : "outline";
    const t6 = type === "icon" ? "icon" : "sm";
    const t7 = type === "icon" ? "h-auto w-auto p-0" : "hover:bg-primary/10";
    let t8;
    if ($[7] !== currentLocale || $[8] !== type) {
      t8 = type === "icon" ? <Languages size={18} /> : <><Globe size={16} />{localeNames[currentLocale]}</>;
      $[7] = currentLocale;
      $[8] = type;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    let t9;
    if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
      t9 = <Button variant={t5} size={t6} className={t7} disabled={true}>{t8}</Button>;
      $[10] = t5;
      $[11] = t6;
      $[12] = t7;
      $[13] = t8;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    return t9;
  }
  let t5;
  if ($[15] !== currentLocale || $[16] !== type) {
    t5 = <DropdownMenuTrigger asChild={true}>{type === "icon" ? <Button variant="ghost" size="icon" className="h-auto w-auto p-0"><Languages size={18} /></Button> : <Button variant="outline" size="sm" className="hover:bg-primary/10"><Globe size={16} />{localeNames[currentLocale]}</Button>}</DropdownMenuTrigger>;
    $[15] = currentLocale;
    $[16] = type;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.keys(localeNames);
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== currentLocale || $[20] !== handleSwitchLanguage) {
    t7 = <DropdownMenuContent>{t6.map(locale => <DropdownMenuItem key={locale} onClick={() => handleSwitchLanguage(locale)}><span>{localeNames[locale]}</span>{locale === currentLocale && <Check size={16} className="text-primary" />}</DropdownMenuItem>)}</DropdownMenuContent>;
    $[19] = currentLocale;
    $[20] = handleSwitchLanguage;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t5 || $[23] !== t7) {
    t8 = <DropdownMenu>{t5}{t7}</DropdownMenu>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}